// 两段文字按词对照：改写建议里删掉的词划掉、加上的词标出来。按最长公共子序列算，空白跟着前面的词走。

export type DiffPart = { type: 'same' | 'del' | 'ins'; text: string }

const tokens = (s: string) => s.match(/\S+\s*|\s+/g) ?? []

export function diffWords(a: string, b: string): DiffPart[] {
  const x = tokens(a)
  const y = tokens(b)
  // 太长就不细比了（几百个词以内够用）：整段删、整段加
  if (x.length * y.length > 250_000) return [{ type: 'del', text: a }, { type: 'ins', text: b }]
  const key = (t: string) => t.trimEnd()
  const n = x.length
  const m = y.length
  const len: number[][] = Array.from({ length: n + 1 }, () => new Array<number>(m + 1).fill(0))
  for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--) len[i][j] = key(x[i]) === key(y[j]) ? len[i + 1][j + 1] + 1 : Math.max(len[i + 1][j], len[i][j + 1])
  const out: DiffPart[] = []
  const push = (type: DiffPart['type'], text: string) => {
    const last = out[out.length - 1]
    if (last?.type === type) last.text += text
    else out.push({ type, text })
  }
  let i = 0
  let j = 0
  while (i < n && j < m) {
    if (key(x[i]) === key(y[j])) {
      push('same', y[j])
      i++
      j++
    } else if (len[i + 1][j] >= len[i][j + 1]) push('del', x[i++])
    else push('ins', y[j++])
  }
  while (i < n) push('del', x[i++])
  while (j < m) push('ins', y[j++])
  return out
}
